<template>
  <div class="animated fadeIn">
    <h3 class="header-title">Learning Find Tutor</h3>
    <label>Let’s see your find tutor message analysis.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your find tutor !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <!-- <CRow>
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </CRow> -->
    <template>
      <template>
        <div>
          <CCard class="mt-4">
            <CRow class="m-0">
              <CCol sm="12">
                <CDataTable
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="Analysis"
                  :fields="fields"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  tableFilter
                  pagination
                >
                <template #StudentInfo="{ item }">
                    <td>
                      <h6 style="color: #1e109c" class="text-uppercase">
                        Student Id : {{ item.StudentId }}
                      </h6>
                      <div>
                        <span class="custom-small text-muted">
                          From User Id :</span
                        >
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.FromUserId }}</span
                        >
                      </div>
                      <div>
                        <span class="custom-small text-muted">Parent Name :</span>
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.Name }}</span
                        >
                        <br />
                        <span class="custom-small text-muted">Student Name :</span>
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.StudentName }}</span
                        >
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Grade :</span>
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.GradeName }}</span
                        >
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Grade :</span>
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.SubjectName }}</span
                        >
                      </div>
                    </td>
                  </template>
                  <template #TeacherInfo="{ item }">
                    <td>
                      <h6 style="color: #1e109c" class="text-uppercase">
                        Teacher Id : {{ item.TeacherId }}
                      </h6>
                      <div>
                        <span class="custom-small text-muted">
                          Teacher Name :</span
                        >
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.Teacher }}</span
                        >
                      </div>
                    </td>
                  </template>
                  <template #OtherInfo="{ item }">
                    <td>
                      <div>
                        <span class="custom-small text-muted">
                          Data Message :</span
                        >
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.DataMessage }}</span
                        >
                      </div>
                      <div>
                        <span class="custom-small text-muted">
                          Description :</span
                        >
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.Description }}</span
                        >
                      </div>
                      <div>
                        <span class="custom-small text-muted">
                          Is Seen :</span
                        >
                        <span
                          class="custom-small-overview custom-text-overview"
                          >{{ item.IsSeen }}</span
                        >
                      </div>
                    </td>
                  </template>
                  <template #CreatedTime="{ item }">
                    <td>
                      <CBadge color="success" class="ml-auto">{{
                        item.CreatedTime | moment("DD MMM YYYY")
                      }}</CBadge>
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
            <CRow> </CRow>
          </CCard>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
Vue.use(VuejsDialog);

export default {
  name: "MsgAnalysis",
  components: {
    cSwitch,
    PulseLoader,
  },
  data: function () {
    return {
      collapse: false,
      Analysis: [],
      fields: [
        { key: "FindTutorId" },
        { key: "StudentInfo" },
        { key: "TeacherInfo" },
        { key: "OtherInfo" },
        { key: "ToUserId" },
        { key: "CreatedTime" },
        { key: "Status" },
        { key: "Type" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetFindTutorMsgAnalysis();
    }
    else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
    async GetFindTutorMsgAnalysis() {
      return this.$API
       .get(this.$FindTutorMsgAnalysis, {
          withCredentials: true,
        })
        .then(
          function (response) {
            this.Analysis = response.data;

          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
  },
};
</script>

<style>
.checkbox-form {
  display: flex;
  flex-direction: column;
  align-items: self-start;
  font-size: 16px;
}
.custom-text-overview {
    color: #000000 !important; 
}
.custom-small-overview {
    font-size: 90%;
    font-weight: 500;
} 
.custom-small {
    font-size: 90%;
    font-weight: 500;
}
.custom-btn-blues{
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
  width: 155px;
}
</style>